// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Dispatch } from 'redux';
import type { RootState } from 'Store';
import { patchJson } from 'Utils/http';
import { API_URL } from 'Config';
import { UpdateProjectReferenceIdAction } from 'Features/project/projectActions';

// Sets, changes, or clears a project's Reference ID (AUT-6449). Its own endpoint, not the
// generic project PATCH: that one refuses every edit once an order is submitted. The store takes
// the value the server kept (trimmed; '' when cleared), never the raw input.
//
// Kept apart from projectThunk on purpose: the shared ReferenceIdEditor imports this from the
// dashboard's cards, and projectThunk drags the map engine in with it.
export const UpdateProjectReferenceIdThunk = (projectData: { _id: string, referenceId: string }) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const url = `${API_URL}/projects/${projectData._id}/referenceId`;
    const { token } = getState().auth;

    const result = await patchJson<{ message: string, referenceId: string }>(url, { referenceId: projectData.referenceId }, token);
    if (result.success) {
      dispatch(UpdateProjectReferenceIdAction({ _id: projectData._id, referenceId: result.data.referenceId }));
    }

    return result;
  };

export default UpdateProjectReferenceIdThunk;
